import { createRoute } from '@tanstack/react-router'

import { appRoute } from '@/app/routes/app-route'
import { entityRoute } from '@/app/routes/entity-route'
import { lazyPage } from '@/lib/lazy-page'

import { settingsRoute } from './settings-route'

export const HomePage = lazyPage(() => import('./features/home/home.lazy'), 'HomePage')

export const homeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: HomePage,
  staticData: { title: 'Home' },
})

export const EntityDashboard = lazyPage(() => import('./features/entity-dashboard/entity-dashboard.lazy'), 'EntityDashboard')

export const entityDashboardRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'dashboard',
  component: EntityDashboard,
  staticData: { title: 'Home' },
})

export const EntitySettings = lazyPage(() => import('./features/entity-settings/entity-settings.lazy'), 'EntitySettings')

export const entitySettingsRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: '/',
  component: EntitySettings,
  staticData: { title: 'General settings' },
})

export const EntityFeaturesSettings = lazyPage(
  () => import('./features/entity-features-settings/entity-features-settings.lazy'),
  'EntityFeaturesSettings',
)

export const entityFeaturesSettingsRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'features',
  component: EntityFeaturesSettings,
  staticData: { title: 'Features settings' },
})

export const EntityPolicies = lazyPage(
  () => import('./features/policies/entity-policies.lazy'),
  'EntityPolicies',
)

export const entityPoliciesRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'policies',
  component: EntityPolicies,
  staticData: { title: 'Policy' },
})

export const NewPolicy = lazyPage(
  () => import('./features/policies/new-policy.lazy'),
  'NewPolicy',
)

export const newPolicyRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'policies/new',
  component: NewPolicy,
  staticData: { title: 'New policy' },
})

export const EntityWhitelabel = lazyPage(
  () => import('./features/whitelabel/entity-whitelabel.lazy'),
  'EntityWhitelabel',
)

export const entityWhitelabelRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: 'whitelabel',
  component: EntityWhitelabel,
  staticData: { title: 'Whitelabel' },
})
